import { Fragment, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import { Container } from '@mui/system';
import SplashScreen from '../spash-screen/splash-screen.component';

const Layout = () => {
    const [splash, setSplash] = useState(false);

    useEffect(() => {
        setSplash(true);
        setTimeout(() => {
            setSplash(false);
        }, 1100);
    }, []);

    return (
        <Fragment>
            <CssBaseline />
            <Container
                maxWidth="sm"
                sx={{
                    padding: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100vh',
                }}
            >
                {splash && <SplashScreen splash={splash} />}
                {!splash && <Outlet />}
            </Container>
        </Fragment>
    );
};

export default Layout;
